// src/data.js
export const questions = [
  {
    question: "Qual é seu ator favorito?",
    options: [
      { text: "Leonardo DiCaprio", score: 1, image: "/images/leonardo_dicaprio.webp" },
      { text: "Will Smith", score: 6, image: "/images/will_smith.webp" },
      { text: "Daniel Radcliffe", score: 5, image: "/images/daniel_radcliffe.avif" },
      { text: "Wagner Moura", score: 4, image: "/images/wagner_moura.webp" },
      { text: "Tom Hanks", score: 1, image: "/images/Tom_Hanks.webp" },
      { text: "Robert De Niro", score: 1, image: "/images/Robert_De_Niro.jpeg" },
      { text: "Ryan Gosling", score: 6, image: "/images/Ryan_Gosling.webp" },
      { text: "Al Pacino", score: 1, image: "/images/Al_Pacino.webp" }
    ]
  },
  {
    question: "Qual é sua atriz favorita?",
    options: [
      { text: "Emma Stone", score: 6, image: "/images/emma_stone.jpeg" },
      { text: "Rachel McAdams", score: 3, image: "/images/Rachel_McAdams.jpeg" },
      { text: "Julia Roberts", score: 6, image: "/images/julia_roberts.jpeg" },
      { text: "Meryl Streep", score: 1, image: "/images/meryl_streep.jpeg"},
      { text: "Zoe Saldaña", score: 6, image: "/images/zoe_saldana.webp" },
      { text: "Emma Watson", score: 5, image: "/images/emma_watson.webp" }
    ]
  },
  {
    question: "Se sua vida tivesse uma trilha sonora, qual seria?",
    options: [
      { text: "Rock/Metal", score: 1, image: "/images/rock_metal.jpeg" },
      { text: "Jazz", score: 2, image: "/images/jazz.jpeg" },
      { text: "Bossa Nova/MPB", score: 4, image: "/images/bossa_nova.jpeg" },
      { text: "Clássica", score: 3, image: "/images/musica_classica.avif" },
      { text: "Hip-Hop/Rap", score: 6, image: "/images/hiphop.jpeg" },
      { text: "Pop", score: 6, image: "/images/pop.jpeg" },
      { text: "Samba", score: 4, image: "/images/samba.jpeg" }
    ]
  },
  {
    question: "Qual é seu livro favorito?",
    options: [
      { text: "Harry Potter", score: 5, image: "/images/harry_potter.jpeg" },
      { text: "Gone Girl", score: 1, image: "/images/gone_girl_livro.jpeg" },
      { text: "The Great Gatsby", score: 1, image: "/images/the_great_book.jpg" },
      { text: "Dune", score: 2, image: "/images/dune_livro.jpeg" },
      { text: "100 anos de solidão", score: 4, image: "/images/100_anos_livro.jpg" },
      { text: "O Corvo", score: 3, image: "/images/o_corvo_livro.jpg" }
    ]
  },
  {
    question: "Depois de um dia de trabalho, que tipo de filme você gosta de assistir?",
    options: [
      { text: "Ação", score: 6, image: "/images/acao.jpeg" },
      { text: "Comédia", score: 1, image: "/images/comedia.webp" },
      { text: "Terror", score: 2, image: "/images/terror.jpeg" },
      { text: "Romance", score: 3, image: "/images/romance.jpeg" },
      { text: "Drama", score: 1, image: "/images/drama.avif" },
      { text: "Fantasia", score: 5, image: "/images/fantasia_wallpaper.jpeg" }
    ]
  },
  {
    question: "Finalmente, qual é seu filme favorito?",
    options: [
      { text: "Tropa de Elite", score: 4, image: "/images/tropa_de_elite.jpeg" },
      { text: "A Origem", score: 2, image: "/images/a_origem.jpeg" },
      { text: "La La Land", score: 6, image: "/images/la_la_land.jpeg" },
      { text: "Velozes e Furiosos", score: 6, image: "/images/velozes_e_furiosos.jpeg" },
      { text: "Harry Potter", score: 5, image: "/images/harry_potter_filme.jpeg" },
      { text: "O Exorcista", score: 2, image: "/images/o_exorcista.jpeg" }
    ]
  }
];

export const destinations = {
  1: { 
    description: "Nova York, EUA: Cosmopolita e vibrante", 
    image: "/images/new_york.jpeg", 
    details: {
      text: "Se você ama a correria, se sente inspirado por arranha-céus imponentes e sempre está de olho na próxima tendência, Nova York é o seu lugar. Cheia de vida, com ruas que nunca param, você vai adorar a energia dessa cidade onde tudo acontece. Se você é o tipo de pessoa que sonha em se destacar, esse match é garantido!",
      cta: "Planeje sua viagem:",
      link: "https://www.topensandoemviajar.com/hoteis-em-nova-york-com-vista"
    }
  },
  2: { 
    description: "Singapura: Moderna e culturalmente diversa", 
    image: "/images/tokyo.jpg", 
    details: {
      text: "Se você é uma pessoa prática, mas ama explorar novas culturas e sabores, Singapura é o seu destino dos sonhos. Imagine uma cidade moderna e organizada, com arranha-céus deslumbrantes, parques futuristas e uma culinária que mistura o melhor do mundo todo. Se você é aquele amigo que está sempre um passo à frente, mas sabe apreciar as tradições, Singapura é o match perfeito para você!",
      cta: "Planeje sua viagem:",
      link: "https://www.topensandoemviajar.com/ficar-marina-bay-sands-singapura"
    }
  },
  3: { 
    description: "Roma, Itália: Histórica e apaixonada", 
    image: "/images/Paris_wallpaper.jpeg", 
    details: {
      text: "Se você é uma pessoa com alma romântica, apaixonada por história e ama uma boa refeição, Roma é sua cidade dos sonhos! Imagine caminhar entre ruínas antigas, admirar arte e arquitetura clássica e, claro, saborear pratos italianos de dar água na boca. Se você é alguém que valoriza o passado, mas vive intensamente o presente, Roma é o seu match ideal.",
      cta: "Planeje uma viagem enoturística inesquecível!",
      link: "https://www.topensandoemviajar.com/enoturismo-italia-roma-florenca"
    }
  },
  4: { 
    description: "Rio de Janeiro, Brasil: Festiva e tropical", 
    image: "/images/rio_de_janeiro.jpeg", 
    details: {
      text: "Ama sol, praia e sempre está com aquele espírito de festa? O Rio de Janeiro é sua cara! Se você adora a vibe descontraída, ama uma boa feijoada e tem energia de sobra para aproveitar o carnaval o ano todo, esse destino é perfeito para você. O Rio é pura alegria e calor humano — combina demais com quem ama estar em movimento.",
      cta: "Saiba onde ficar no Rio!",
      link: "https://www.topensandoemviajar.com/resorts-rj"
    }
  },
  5: { 
    description: "Peru: Místico e aventureiro", 
    image: "/images/londres_wallpaper.jpeg", 
    details: {
      text: "Se você é o tipo de pessoa que ama se conectar com a natureza, a espiritualidade e tem um espírito explorador, o Peru é seu match perfeito. De Machu Picchu às selvas amazônicas, o país é um prato cheio para quem adora aventuras e mistérios antigos. Se a ideia de descobrir novas culturas, trilhas e sabores te empolga, o Peru vai mexer com sua alma de explorador.",
      cta: "Planeje sua viagem com desconto já!",
      link: "https://www.topensandoemviajar.com/viagem-peru"
    }
  },
  6: { 
    description: "Buenos Aires, Argentina: Apaixonada e cheia de estilo", 
    image: "/images/los_angeles.jpeg", 
    details: {
      text: "Se você tem uma personalidade intensa e gosta de viver com paixão, a Argentina é o seu lugar. De Buenos Aires com seus tangos dramáticos e cafés charmosos até as paisagens impressionantes da Patagônia, esse país combina arte, cultura e natureza em um pacote irresistível. Se você curte boa comida, bons vinhos e tem um lado artístico, a Argentina é o destino que vai fazer seu coração bater mais forte!",
      cta: "Que tal aproveitar noites de tango na capital argentina?",
      link: "https://www.topensandoemviajar.com/tango-em-buenos-aires"
    }
  }
};
